// Main exports
export { KycModal } from "./widgets/kyc/KycModal";

// Store exports
export { useKycStore } from "./stores/useKycStore";
export { useCardStatusStore } from "./stores/cardStatusStore";
export { useCreditStore } from "./stores/creditStore";
export { useSDKConfigStore } from "./stores/sdkConfigStore";

// API exports
export {
  freezeCard,
  getCardStatus,
  getUserCards,
  getCreditInformation,
  getSumSubAccessToken,
  getCreditDelegationTxData,
  linkCardToCreditAccount,
} from "./api/api";

// Card activation exports
export { delegateCard } from "./core/cardActivation";
export type { DelegateCardParams } from "./core/cardActivation";

// SDK exports
export { initializeSwypeSDK } from "./api/sdk";
export { generateAuthSign } from "./api/auth";
export type { SwypeSDKConfig, AuthSignature } from "./api/types";
export type {
  CardStatusResponse,
  UserCardsResponse,
  CreditInformationResponse,
  SuppliedAsset,
  BorrowedAsset,
  CreditMetadata,
  SumSubTokenResponse,
  CreditDelegationRequest,
  CreditDelegationResponse,
  LinkCardRequest,
} from "./api/types";

// Component exports
export { Modal } from "./components/Modal";
export { SumSubWidget } from "./components/SumSubWidget";

// Hook exports
export { useSumSub } from "./hooks/use-sumsub";
export { useCardData } from "./hooks/useCardData";
export { useCreditData } from "./hooks/useCreditData";
export type { SumsubMessage } from "./hooks/use-sumsub";

// Type exports
export type { CardStatus, UserCard } from "./api/types";

// CSS import
import "./styles.css";

// Export data fetcher for manual triggering if needed
export { dataFetcher } from "./core/dataFetcher";
